module.exports = __webpack_public_path__ + "img/paypal_logo.9a7ad06f.png";